<template>
  <div>
    <a-form :form="form">
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Date of PP">
            <a-date-picker
              placeholder="Select Date"
              :disabled="mode === 'Edit'"
              :format="getDefaultDateFormat"
              v-decorator="[
                'tgl_buat',
                {
                  rules: [{ required: true }],
                  initialValue: moment(
                    initialData.informasi.tgl_buat,
                    getDefaultDateFormat
                  ),
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="Jenis Anggaran">
            <a-select
              :disabled="
                mode == 'Edit' ||
                (this.listPembelian !== undefined &&
                  this.listPembelian.length > 0)
              "
              showSearch
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'jenis_anggaran',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.informasi.jenis_anggaran,
                },
              ]"
              @change="handleJenisAnggaran"
            >
              <a-select-option
                v-for="item in getJenisAnggaran"
                :key="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="Cost Center">
            <a-select
              ref="costCntr"
              :disabled="
                mode == 'Edit'
                  ? true
                  : costCenter.length == 0 ||
                    (this.listPembelian !== undefined &&
                      this.listPembelian.length > 0)
              "
              showSearch
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'cost_center',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.informasi.cost_center,
                },
              ]"
              @change="handleCost"
            >
              <a-select-option v-for="item in costCenter" :key="item.value"
                >{{ item.text }} ({{
                  item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                }})</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="Peruntukan">
            <a-select
              :disabled="
                mode == 'Edit'
                  ? true
                  : peruntukan.length == 0 ||
                    (this.listPembelian !== undefined &&
                      this.listPembelian.length > 0)
              "
              showSearch
              :not-found-content="null"
              :loading="load.peruntukan"
              option-filter-prop="children"
              v-decorator="[
                'peruntukan',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.informasi.peruntukan,
                },
              ]"
              @change="handlePeruntukan"
            >
              <a-select-option v-for="item in peruntukan" :key="item.value">{{
                item.text
              }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-row :gutter="24">
            <a-col span="0" style="display:hidden">
              <a-form-item label="Activity Type"
                v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV')">
                <a-select placeholder="Please Select" 
                ref="refactivity_type"
                v-decorator="[
                  'type_activity',
                  { rules: [{ required: true }], initialValue: initialData.informasi.type_activity },
                ]"
                @change="changeActivity_type" class="width-full" disabled>
                  <a-select-option v-for="item in getMARDEVActivity.type" :key="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col span="24">
              <a-form-item label="Activity" v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV') && $refs.refactivity_type && $refs.refactivity_type.value=='Non Project'">
                <a-select placeholder="Please Select" 
                v-decorator="[
                  'activity',
                  { rules: [{ required: true }], initialValue: initialData.informasi.activity },
                ]" class="width-full">
                  <a-select-option v-for="item in getMARDEVActivity.activity" :key="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Pipeline" v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV') && $refs.refactivity_type && $refs.refactivity_type.value=='Project Penetration'">
                <a-select
                  :disabled="mode == 'Edit'"
                  showSearch
                  :loading="load.pipeline"
                  :not-found-content="null"
                  option-filter-prop="children"
                  v-decorator="[
                    'pipeline_id',
                    {
                      rules: [{ required: true }],
                      initialValue: initialData.informasi.pipeline,
                    },
                  ]"
                >
                  <a-select-option v-for="item in pipelineList" :key="item.pipeline_id">
                    [{{ item.pipeline_no}}] {{ item.definitions }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Category">
            <a-select
              showSearch
              :disabled="disabledUserfor"
              :loading="loadUserfor"
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'used_for',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.informasi.used_for,
                },
              ]"
            >
              <a-select-option
                v-for="item in listUseFor"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="Description">
            <a-input
              v-decorator="[
                'deskripsi',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.informasi.deskripsi,
                },
              ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Be Required">
            <a-date-picker
              placeholder="Select Date"
              :format="getDefaultDateFormat"
              allowClear
              v-decorator="[
                'be_required',
                {
                  rules: [{ required: true }],
                  initialValue: moment(
                    initialData.informasi.be_required,
                    getDefaultDateFormat
                  ),
                },
              ]"
            />
          </a-form-item>
          <!--        <a-form-item label="Lead Time" hidden>-->
          <!--          <a-input-->
          <!--            v-decorator="[-->
          <!--              'lead_time',-->
          <!--              {-->
          <!--                rules: [{ required: false }],-->
          <!--                initialValue: '',-->
          <!--              },-->
          <!--            ]"-->
          <!--          ></a-input>-->
          <!--        </a-form-item>-->

          <!--        <a-form-item label="Lead Time" hidden>-->
          <!--          <a-input-->
          <!--                  v-decorator="[-->
          <!--              'lead_time',-->
          <!--              {-->
          <!--                rules: [{ required: true }],-->
          <!--                initialValue: initialData.informasi.lead_time,-->
          <!--              },-->
          <!--            ]"-->
          <!--          ></a-input>-->
          <!--        </a-form-item>-->
          <a-form-item label="End User">
            <a-select
              :disabled="mode == 'Edit' ? true : false"
              ref="fenduser"
              showSearch
              v-decorator="[
                'end_user',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.informasi.end_user,
                },
              ]"
            >
              <a-select-option
                v-for="item in getAllKaryawan"
                :key="item.tlc"
                :value="item.tlc"
                >{{ item.tlc }} - {{ item.nama }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <!-- <a-form-item label="Used For" hidden>
          <a-checkbox-group
            v-decorator="[
              'used_for',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.used_for,
              },
            ]"
          >
            <a-row type="flex">
              <a-col>
                <a-checkbox value="po">
                  PO
                </a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value="wo">
                  WO
                </a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value="klaim">
                  KLAIM
                </a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value="umpp">
                  UM PP
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-item> -->
        <a-form-item label="Prospect No" v-if="selectedCostCenter=='07'">
            <a-select
              showSearch
              :allowClear="(getTlc_CEO==end_user_pp.value ? true : false)"
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'prospek',
                {
                  rules: [{ required: (getTlc_CEO==end_user_pp.value ? false : true) }], initialValue: initialData.informasi.prospek
                },
              ]"
              :disabled="peruntukan.length == 0"
            >
              <a-select-option
                v-for="item in listProspect"
                :key="item.id_prospek"
              >
                {{ item.no_prospek }} - {{ item.description }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-modal
      v-model="modalanggaran.visible"
      v-if="modalanggaran.visible"
      title="Choice Financing Code"
      :footer="null"
      :width="700"
    >
      <a-tree-select
        v-model="modalanggaran.value"
        show-search
        style="width: 100%"
        @change="handlechoiceCost"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="modalanggaran.tree"
        treeNodeFilterProp="children"
        :filterTreeNode="filterTreeNode"
        placeholder="Please select"
        allow-clear
        tree-default-expand-all
      >
        <span slot="title" slot-scope="item">
          <table style="width: 100%">
            <tr>
              <td>
                <span> {{ item.texttitle }} - {{ item.kode_anggaran }}</span>
              </td>
              <td>
                <span style="float: right">
                  {{ formatRupiah(parseFloat(item.rekap)) }}
                </span>
              </td>
            </tr>
          </table>
        </span>
      </a-tree-select>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "Informasi",
  props: {
    listPembelian: {},
    data: {},
    persetujuan: {},
    projectAllsts: {},
    mode: String,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      peruntukan: [],
      subPeruntukan: [],
      anggaran: [],
      costCenter: [],
      modalanggaran: {
        visible: false,
        enabled: false,
        loadingButton: false,
        value: undefined,
        tree: {},
        searchValue: "",
      },
      loadUserfor: false,
      disabledUserfor: true,
      listUseFor: [
        {
          text: "Technic item/service purchasing",
          value: "1",
        },
        {
          text: "Non technic item/service purchasing",
          value: "2",
        },
        {
          text: "Payment instruction",
          value: "3",
        },
        // {
        //   text: "Commission",
        //   value: "4",
        // },
        {
          text: "Other",
          value: "5",
        },
        {
          text: "Recapitulation",
          value: "6",
        }
      ],
      pipelineList: [],
      load:{
        peruntukan: false,
        pipeline: false
      },
      // visible:{
      //   vjAnggaran: false,
      //   vjCostCenter: false,
      //   vjPeruntukan: false,
      //   vjSUbPeruntukan: false,
      //   vjKodeAnggaran: false,
      //
      // }
      listProspect:[],
      selectedCostCenter: []
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getAllKaryawan",
      "getDefaultDateFormat",
      "getAuth",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
      "getJenisAnggaran",
      "getMARDEVActivity",
      "getTlc_CEO"
    ]),
    initialData() {
      let informasi = {};
      if (this.data === undefined || this.data.length == 0) {
        informasi = {
          tgl_buat: moment().utc(true),
          be_required: moment().utc(true),
          deskripsi: "",
          end_user: "",
          lead_time: "",
          used_for: "",
          cost_center: "",
          peruntukan: "",
          sub_peruntukan: "",
          kode_anggaran: "",
          jenis_anggaran: "",
          pipeline: "",
          type_activity: 'Non Project',
          activity: null,
          prospek: null
        };
        return { informasi };
      } else {
        this.initJenisAnggaran(
          this.data.jns_anggaran_id || this.data.jenis_anggaran
        );
        this.initCost(this.data.cost_center);
        this.handlePeruntukan(this.data.peruntukan);
        //this.handleSubPeruntukan(this.data.sub_peruntukan);
        this.handleCodeAnggarn(this.data.kode_anggaran);
        //this.handleCost(this.data.cost_center)

        informasi = {
          used_for: this.data.used_for,
          tgl_buat: moment(this.data.tgl_buat).format(
            this.getDefaultDateFormat
          ),
          be_required: moment(this.data.be_required).format(
            this.getDefaultDateFormat
          ),
          deskripsi: this.data.deskripsi,
          end_user: this.data.end_user,
          lead_time: this.data.lead_time,
          cost_center: this.data.cost_center,
          peruntukan: this.data.peruntukan,
          sub_peruntukan: this.data.sub_peruntukan,
          kode_anggaran: this.data.kode_anggaran,
          jenis_anggaran: this.data.jenis_anggaran || this.data.jns_anggaran_id,
          pipeline: this.data.pipeline_id,
          type_activity: this.data.type_activity,
          activity: this.data.activity,
          prospek: this.data.prospek
        };
        return { informasi };
      }
    },
    end_user_pp(){
      return this.$refs.fenduser
    }
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    this.$store.dispatch("FETCH_COST_CENTER");
  },
  mounted() {
    if (this.mode == "Create") {
      if (this.initialData.informasi) {
        if (
          this.initialData.informasi.jenis_anggaran !== undefined &&
          this.initialData.informasi.jenis_anggaran !== null &&
          this.initialData.informasi.jenis_anggaran !== ""
        ) {
          if(this.listPembelian.length>0){
            this.disabledUserfor = true;
          }else{
            this.disabledUserfor = false;
          }
        }
      }
    }

    if(this.data && (this.data.jenis_anggaran=='07' || this.data.jns_anggaran_id=='07')){
      this.selectedCostCenter = this.data.jenis_anggaran || this.data.jns_anggaran_id
      this.getProspectList();
    }
  },
  methods: {
    moment,
    handleCodeAnggarn(e) {
      let forms = this.form.getFieldsValue();
      this.modalanggaran.value =
        forms.peruntukan + ";" + forms.sub_peruntukan + ";" + e;
    },
    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(val) {
      if (val) {
        let kod = val.split(";");
        this.$nextTick(function () {
          this.handlePeruntukan(kod[0]);
          this.form.setFieldsValue({
            peruntukan: kod[0],
          });
          //this.handleSubPeruntukan(kod[1]);
          this.form.setFieldsValue({
            sub_peruntukan: kod[1],
            kode_anggaran: kod[2],
          });
        });
      } else {
        this.$nextTick(function () {
          this.form.setFieldsValue({
            peruntukan: undefined,
            sub_peruntukan: undefined,
            kode_anggaran: undefined,
          });
        });
      }
      this.modalanggaran.visible = false;
    },
    showChoiceModal() {
      this.modalanggaran.visible = true;
    },
    async handleCost(e) {
      this.modalanggaran.enabled = false;
      this.modalanggaran.loadingButton = true;
      this.modalanggaran.value = undefined;

      const ax_tree_anggaran = axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/tree_anggaran",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });

      const ax_pipeline = axios({
        method: "get",
        url: this.$serviceUrl + "pp/pipeline",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })

      this.load.peruntukan = true
      this.load.pipeline = true
      await axios
        .all([
          // ax_tree_anggaran.catch((err) => {
          //   if (!err.response) {
          //     let responses = Object.assign({}, err.response);
          //     this.displayMessageValue("error", responses);
          //   } else {
          //     console.log(err);
          //   }
          //   return null;
          // }),
          ax_pipeline.catch((err) => {
            if (!err.response) {
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            } else {
              console.log(err);
            }
            return null;
          }),
      ]).then((response) => {
        this.load.peruntukan = false
        this.load.pipeline = false
        
        // this.modalanggaran.tree = response[0].data.tree;

        this.pipelineList = response[0].data.data?response[0].data.data:[]

        if(this.selectedCostCenter=='07'){
          this.getProspectList();
        }else{
          this.modalanggaran.enabled = true;
          this.modalanggaran.loadingButton = false;
        }
      })

      this.form.resetFields(["pipeline", "peruntukan", "sub_peruntukan", "kode_anggaran"]);
      this.form.setFieldsValue({ peruntukan: null });
      this.form.setFieldsValue({ sub_peruntukan: null });
      this.form.setFieldsValue({ kode_anggaran: null });
      this.form.setFieldsValue({ pipeline: null });

      if(e && e.includes('MARDEV')){
        this.form.setFieldsValue({ activity_type: "Non Project", end_user: this.getTlc_CEO });
      }

      this.subPeruntukan = [];
      this.anggaran = [];
      const peruntukan = this.getPeruntukan.filter(
        (item) => item.anggaran_id == e
      );

      this.peruntukan = peruntukan;
    },
    handlePeruntukan(e) {
      this.modalanggaran.value = undefined;
      this.form.resetFields(["sub_peruntukan", "kode_anggaran"]);
      this.anggaran = [];
      const filter = this.getSubPeruntukan.filter(
        (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.subPeruntukan = filter;
    },
    // handleSubPeruntukan(e) {
    //   this.modalanggaran.value = undefined;
    //   this.form.resetFields(["kode_anggaran"]);
    //   const filter = this.getAnggaran.filter(
    //     (obj) => obj.anggaran_dtl_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
    //   );
    //   this.anggaran = filter;
    // },
    // async getApproval(anggaran_id) {
    //   return await axios({
    //     method: "get",
    //     url: this.$serviceUrl + "pp/approval_pp",
    //     params: {
    //       tlc : this.getAuth.username,
    //       anggaran_dtl_val_id: anggaran_id,
    //     },
    //     auth: {
    //       username: this.getAuth.username,
    //       password: this.getAuth.password,
    //     },
    //     headers: {
    //       "X-API-KEY": this.getAuth.apikey,
    //     },
    //   });
    // },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        //let approval = "";
        // this.getApproval(values.kode_anggaran)
        //   .then((res) => {
        //     //approval = res.data;
        //     const dataValues = {
        //       ...values,
        //       tgl_buat: moment(values.tgl_buat).format(
        //         this.getStandartFormatDate
        //       ),
        //       be_required: moment(values.be_required).format(
        //         this.getStandartFormatDate
        //       ),
        //       //approval: res.data.approval,
        //     };
        //     Event.$emit("ppData", {
        //       informasi: dataValues,
        //     });
        //   })
        //   .catch((err) => {
        //     if (err.response) {
        //       this.$notification.error({
        //         message: "Error Message",
        //         description: err.response.data.message,
        //       });
        //     }
        //     return err;
        //   });

        const cost_center_text = this.costCenter.filter(item => item.value==values.cost_center)[0].text

        const dataValues = {
          ...values,
          tgl_buat: moment(values.tgl_buat).format(this.getStandartFormatDate),
          be_required: moment(values.be_required).format(
            this.getStandartFormatDate
          ),
          approval: null,
          bailout_transfer: (this.data && this.data.bailout_transfer ? this.data.bailout_transfer : 0),
          cost_center_text: cost_center_text
        };
        Event.$emit("ppData", {
          informasi: dataValues,
        });
      });
    },
    handleJenisAnggaran(e) {
      this.selectedCostCenter = e
      this.listProspect = []
      this.form.setFieldsValue({ cost_center: null });
      this.form.setFieldsValue({ peruntukan: null });
      this.form.setFieldsValue({ sub_peruntukan: null });
      this.form.setFieldsValue({ kode_anggaran: null });
      const filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.modalanggaran.enabled = false;
      this.costCenter = filter;
      this.peruntukan = [];
      this.subPeruntukan = [];
      this.anggaran = [];
      this.modalanggaran.value = null;

      this.loadUserfor = true;
      this.disabledUserfor = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "pp/used_for",
        params: {
          jenis_anggaran: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          //console.log(response);
          this.listUseFor = response.data.data;
          this.$nextTick(function () {
            this.form.setFieldsValue({
              used_for: undefined,
            });
          });
          this.disabledUserfor = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          console.log(responses);
        });
      this.loadUserfor = false;
    },
    initJenisAnggaran(e) {
      let filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.modalanggaran.enabled = false;
      this.costCenter = filter;
    },
    initCost(e) {
      this.modalanggaran.enabled = false;
      this.modalanggaran.loadingButton = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/tree_anggaran",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          //console.log(response);
          this.modalanggaran.enabled = true;
          this.modalanggaran.loadingButton = false;
          this.modalanggaran.tree = response.data.tree;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          console.log(responses);
        });

        const ax_pipeline = axios({
        method: "get",
        url: this.$serviceUrl + "pp/pipeline",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })

      this.load.peruntukan = true
      this.load.pipeline = true
      axios
        .all([
          ax_pipeline.catch((err) => {
            if (!err.response) {
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            } else {
              console.log(err);
            }
            return null;
          }),
      ]).then((response) => {
        this.load.peruntukan = false
        this.load.pipeline = false
        
        this.modalanggaran.enabled = true;
        this.modalanggaran.loadingButton = false;

        this.pipelineList = response[0].data.data?response[0].data.data:[]
      })

      this.form.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);

      // this.subPeruntukan = [];
      // this.anggaran = [];
      const peruntukan = this.getPeruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.peruntukan = peruntukan;
    },
    changeActivity_type(val){
      if(val=="Non Project"){
        this.$nextTick(function () {
          this.form.setFieldsValue({
            activity: null,
          });
        });
      }else{
        this.$nextTick(function () {
          this.form.setFieldsValue({
              pipeline_id: null,
          });
        });
      }
    },
    async getProspectList(){
      await axios({
        method: "get",
        url: this.$serviceUrl + "prospek/pilih_prospek",
        params: {
          anggaran_id: this.$refs.costCntr.value
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(async (response) => {
        this.listProspect = await (response.data.data ? response.data.data : []);

        this.modalanggaran.enabled = true;
        this.modalanggaran.loadingButton = false;
      })
      .catch(() => {
      });
    }
  },
  watch:{
    initialData(){
      if(this.mode == "Edit"){
        if(this.initialData.informasi.used_for=='3' || this.initialData.informasi.used_for=='6'){ //Payment instruction
          this.disabledUserfor = true;
        }else{
          this.disabledUserfor = false;
          this.listUseFor = this.listUseFor.filter(item => item.value!='3' && item.value!='6')
        }
      }
    }
  }
};
</script>

<style lang="less">
.ant-select-selection-selected-value {
  width: 100%;
}
</style>
